'use client';

import React, { AnchorHTMLAttributes, useState } from 'react';
import AppDirAuthIFrame from '~/components/LoginRegister/AuthIFrame/AppDirAuthIFrame';
import SimpleModal from '~/components/NewModal/SimpleModal';

export default function ManagedLoginRegisterModal({
  asChild,
  defaultView,
  children,
  ...props
}: {
  asChild?: boolean;
  children: React.ReactNode;
  defaultView?: 'login' | 'register';
}) {
  const [open, setOpen] = useState(false);
  function handleSuccessfulLogin() {
    setOpen(false);
  }

  function handleOpen(e: React.MouseEvent) {
    e.preventDefault();
    e.stopPropagation();
    setOpen(true);
  }

  return (
    <>
      {asChild ? (
        React.cloneElement(
          React.Children.only(children) as React.ReactElement<
            AnchorHTMLAttributes<HTMLAnchorElement>
          >,
          {
            onClick: handleOpen,
            'data-disable-nprogress': true,
          },
        )
      ) : (
        <button onClick={handleOpen}>children</button>
      )}

      <SimpleModal open={open} onClose={() => setOpen(false)} {...props}>
        <AppDirAuthIFrame
          initialView={
            defaultView === 'login'
              ? 'login'
              : defaultView === 'register'
                ? 'register'
                : undefined
          }
          onSuccessfulLogin={handleSuccessfulLogin}
        />
      </SimpleModal>
    </>
  );
}
